export default __webpack_public_path__ + "static/how_it_work-a8cc4e86f1f1ec23b17694fd87a8f2d4.jpg";